import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { logout } from '../../actions/AuthAction'
import { getCustomsClients } from '../../utils'

export class Logout extends Component {

  componentDidMount() {
    const { pid, user } = this.props
    if (pid) clearInterval(pid)


    if (user && user.workClients) {
      const customClients = getCustomsClients()
      const hasMatchingClient = user.workClients.some(clientId =>
        customClients.map(r => r._id).flat().includes(clientId)
      );
      if (hasMatchingClient) {
        this.props.logout(this.props.history, true)
      } else {
        this.props.logout(this.props.history)
      }
    } else {
      this.props.logout(this.props.history)
    }
  }

  componentDidUpdate() {
    this.props.logout(this.props.history)
  }

  render() {
    return (<div></div>)
  }
}

const mapStateToProps = state => {
  return {
    pid: state.notifications.pid,
    user: state.authUser.user,
  }
}

const mapDispatchToProps = {
  logout
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(Logout)))